// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3bf2a043","977":"9068158a"}[chunkId] + ".chunk.js";
};